import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { prepareLessonListFromCourse } from '@/Module/Lesson/Helper';
import type { ICourse } from '@/Module/Lesson/Model/DataModel';
import {
  getCourseByCategoryCategoryIdAction,
  getCourseBySlugAction,
  getCourseBySlugAndCategoryCategoryIdAction,
} from '@/Module/Lesson/Store/Action';
import { lessonAdapter } from '@/Module/Lesson/Store/Adapter';

const LessonSlice = createSlice({
  name: 'lesson',
  initialState: lessonAdapter.getInitialState({
    isLoading: false,
    activeTabNumber: 1,
    selectedCourseId: null as ICourse['id'] | null,
  }),
  reducers: {
    setSelectedCourseId: (state, { payload }: PayloadAction<ICourse['id'] | null>) => {
      state.selectedCourseId = payload;
    },
    setActiveTabNumber: (state, { payload }: PayloadAction<number>) => {
      state.activeTabNumber = payload;
    },
  },
  extraReducers: builder => {
    // get course list by categoryCategoryId
    builder
      .addCase(getCourseByCategoryCategoryIdAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getCourseByCategoryCategoryIdAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getCourseByCategoryCategoryIdAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        lessonAdapter.setAll(state, prepareLessonListFromCourse(payload));
      });

    // get course by gradeSlug
    builder
      .addCase(getCourseBySlugAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getCourseBySlugAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getCourseBySlugAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;

        lessonAdapter.setOne(state, prepareLessonListFromCourse([payload])[0]);
      });

    // get course by gradeSlug
    builder
      .addCase(getCourseBySlugAndCategoryCategoryIdAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getCourseBySlugAndCategoryCategoryIdAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getCourseBySlugAndCategoryCategoryIdAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;

        lessonAdapter.setOne(state, prepareLessonListFromCourse([payload])[0]);
      });
  },
});

export const { setSelectedCourseId: lessonSetSelectedCourseId, setActiveTabNumber: lessonSetActiveTabNumber } =
  LessonSlice.actions;

export default LessonSlice;
